@import '~style-sheet-helpers/core.less';
@import (reference) '../../constants/spacing.module.less';

.carrier-tag-bank {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.carrier-tag {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--grey-300);
  border-radius: @space-4;
  padding: @space-8;
  gap: @space-8;
}

.carrier-logo {
  width: 24px;
  height: 24px;
  padding: 3px;
}

.account-nickname {
  font-size: 14px;
  color: var(--grey-600);
}

.bullet {
  margin-top: 2px;
}

.international-services-header {
  margin-left: @space-4;

  &.being-edited {
    margin: @space-16 0 @space-8;
  }
}
